import React from "react";
import { TrendingUp, FileText, CheckCircle } from "lucide-react";
import { StatCard, StatCardSkeleton } from "src/components/ui/statCard";

interface ClaimsStatsCardsProps {
  isLoading: boolean;
  totalOngoingPrice: number;
  totalOngoingClaims: number;
  totalClaims: number;
  totalApprovedPrice: number;
}

export const ClaimsStatsCards: React.FC<ClaimsStatsCardsProps> = ({
  isLoading,
  totalOngoingPrice,
  totalOngoingClaims,
  totalClaims,
  totalApprovedPrice
}) => (
  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
    {isLoading ? (
      <>
        <StatCardSkeleton variant="flat" />
        <StatCardSkeleton variant="flat" />
        <StatCardSkeleton variant="flat" />
      </>
    ) : (
      <>
        <StatCard
          variant="flat"
          icon={TrendingUp}
          title="Total Ongoing Claims Value"
          value={`£${totalOngoingPrice.toFixed(2)}`}
          iconBgClass="bg-primary-100"
          iconColorClass="text-primary-700"
        />
        <StatCard
          variant="flat"
          icon={CheckCircle}
          title="Total Approved Claims Value"
          value={`£${totalApprovedPrice.toFixed(2)}`}
          iconBgClass="bg-emerald-100"
          iconColorClass="text-emerald-700"
        />
        <StatCard
          variant="flat"
          icon={FileText}
          title="Claims in Progress"
          value={`${totalOngoingClaims} / ${totalClaims}`}
          iconBgClass="bg-secondary-100"
          iconColorClass="text-secondary-700"
        />
      </>
    )}
  </div>
);
